import {Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

import {Travel} from '../../models/travel';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';
import {SnackBarHandlerService} from '../../commons/snack-bar-handler.service';

@Component({
	selector: 'app-compile-warrant',
	templateUrl: './compile-warrant.component.html',
	styleUrls: ['./compile-warrant.component.css']
})
export class CompileWarrantComponent {
	maxDate = new Date();
	modalRef: BsModalRef;
	travelToCompile: Travel;
	@ViewChild('template', { static: false }) template;
	@Output() travelStarted = new EventEmitter<boolean>();

	dom_elements = {
		assign_btn: {
			is_running: false,
			txt_run: 'SALVATAGGIO IN CORSO...',
			txt_not_run: 'INIZIA VIAGGIO'
		},
		startTrip: {
			is_running: false,
			txt_run: 'CREAZIONE VIAGGIO IN CORSO...',
			txt_not_run: 'INIZIA VIAGGIO'
		},
		active_step: 0

	};

	constructor(
		public travelsHandlerService: TravelsHandlerService,
		public travelsService: TravelsHandlerService,
		public snackBarHandler: SnackBarHandlerService,
		private modalService: BsModalService
	) { }

	onDateChange (e) {
		if (e > this.maxDate) {
			this.travelToCompile.started_at_app = this.maxDate;
		}
	}

	showDialog(travelToCompile: Travel) {
		this.travelToCompile = travelToCompile;
		this.travelToCompile.started_at_app = new Date();
		this.maxDate = new Date();

		this.travelsService
		.getMaxKm(this.travelToCompile)
		.then((res) => {
			this.travelToCompile.start_kilometers = res.toString();
		})
		.catch((er) => {});

		/*
		this.travelsService.getMaxKm(this.travelToCompile).then((res) => {
		console.log(res);
		if (this.travel.travelStarted()) {
			this.travel.end_kilometers = (res ).toString();
			this.viewEndTrip();
		} else {
			this.travel.start_kilometers = (res ).toString();
			this.viewStartTrip();
		}

		}).catch((er) => {

		}).then(() => {
		this.dom_elements.refresh_is_running = false;
		});

	*/

		this.modalRef = this.modalService.show(this.template);
	}

	sendWarrant() {
		this.dom_elements.startTrip.is_running = true;

		if (this.isStartTravelComplete()) {

			this.getCurrentPosition((lat, lon, alt) => {

				this.travelToCompile.start_latitude = lat;
				this.travelToCompile.start_longitude = lon;
				this.travelToCompile.start_altitude = alt;

				this.travelsService.startTravel(this.travelToCompile).then((travel: Travel) => {
					this.travelToCompile = travel;
					this.travelStarted.emit();
					this.modalRef.hide();
					// this.viewEndTrip();

				}, (err) => {
					this.snackBarHandler.showSnackbar('Attenzione creazione viaggio fallita, ' +
						'verifica se esiste già un viaggio aperto e assicurati che il numero di chilometri sia corretto. Ricarica la pagina.', 3000);
				}).catch().then(() => {
					this.dom_elements.startTrip.is_running = false;
				});
			});

		} else {
			this.dom_elements.startTrip.is_running = false;
		}
	}

	isStartTravelComplete(): boolean {
		let isComplete = false;

		if (!this.travelToCompile.started_at_app) {
			this.snackBarHandler.showSnackbar('Impostare data di inizio viaggio valida', 3000);
		} else if (!this.travelToCompile.start_kilometers) {
			this.snackBarHandler.showSnackbar('Impostare chilometri attuali autovettura', 3000);
		} else if (!this.travelToCompile.vehicle.id) {
			this.snackBarHandler.showSnackbar('Impostare un veicolo valido', 3000);
		} else if (isNaN(Number(this.travelToCompile.start_kilometers))) {
			this.snackBarHandler.showSnackbar('Valore kilometri non valido', 3000);
		} else {
			isComplete = true;
		}

		return isComplete;
	}

	getCurrentPosition(callbackFunction) {
		callbackFunction(null, null, null);
		// navigator.geolocation.getCurrentPosition((position) => {
		// 	callbackFunction(position.coords.latitude, position.coords.longitude, position.coords.altitude);
		// }, (err) => {
		// 	callbackFunction(null, null, null);
		// });
	}

	// da verificare utilità
	/*viewEndTrip() {
    window.scrollTo( 0 , 0 );
    this.dom_elements.active_step = 2;
    this.travelToCompile.ended_at = new Date();
    this.travelsService.getMaxKm(this.travelToCompile).then((res) => {
      console.log(res);
      this.travelToCompile.end_kilometers = (res).toString();

    }).catch((er) => {
    });
    this.deactivateAll();
  }*/


}
